/**
 * @fileoverview Modal component for displaying modal dialogs in the Storyteller web application.
 * This component provides a backdrop and modal dialog with optional close button and custom content.
 *
 * @example
 * // Basic usage
 * <Modal render={() => <div>Modal Content</div>} onClose={() => {}} />
 */

import css from './Modal.module.css'
import { ModalConfig } from './ModalContext'

Modal.defaultProps = {
    confirmText: 'buttons.yes',
    cancelText: 'buttons.no',
    canClose: true,
}

/**
 * @function Modal
 * @description Component for displaying modal dialogs in the Storyteller web application.
 * @param {ModalConfig} props - The props for the Modal component.
 * @returns {JSX.Element} The Modal component.
 */
export function Modal(props: ModalConfig) {
    return (
        <div className={css.backdrop}>
            <div className={css.modal}>
                {props.canClose && (
                    <button
                        data-testid="close-modal"
                        className={css.closeIconContainer}
                        onClick={props.onClose}
                    >
                        <img
                            src="https://novoic-static.s3.us-west-2.amazonaws.com/close.svg"
                            alt="Close modal"
                        />
                    </button>
                )}
                {props.render(props)}
            </div>
        </div>
    )
}
